import _map from 'lodash/map';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { percentify } from 'utilities/videoPlayer';

import './styles.less';

class LoadProgressBar extends Component {
  render() {
    const { bufferedParts, duration } = this.props;

    if (bufferedParts.length === 0) {
      return null;
    }

    let { end: bufferedEnd } = bufferedParts[bufferedParts.length - 1];

    if (bufferedEnd > duration) {
      bufferedEnd = duration;
    }

    const style = {
      // the width of the load progress bar
      width: percentify(bufferedEnd, duration),
    };

    // add child elements to represent the individual bufferedParts time ranges
    const parts = _map(bufferedParts, ({ start, end }, keyIndex) => (
      <div
        className="buffered-part"
        style={{
          // set the percent based on the width of the progress bar (bufferedEnd)
          left: percentify(start, bufferedEnd),
          width: percentify(end - start, bufferedEnd),
        }}
        key={keyIndex}
      />
    ));

    return (
      <div className="video-player-load-progress-bar" style={style}>
        {parts}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { buffered_parts: bufferedParts } = state.video_player;

  return { bufferedParts };
};

export default connect(mapStateToProps)(LoadProgressBar);
